// Formateadores para Colombia.

const cop = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

export const formatoCOP = (n) => cop.format(Number(n) || 0);

const rtf = new Intl.RelativeTimeFormat('es-CO', { numeric: 'auto' });

/// Parsea una fecha del backend. Si viene sin sufijo de zona (típico
/// cuando .NET/PostgreSQL devuelve DateTime con Kind=Unspecified), la
/// asume UTC y le agrega 'Z' para que JavaScript no la interprete como
/// hora local. Backend guarda todo en UTC — al mostrar, el navegador
/// convierte a hora del usuario automáticamente.
function parsearFechaBackend(fechaIso) {
  if (!fechaIso) return null;
  const s = String(fechaIso);
  // Si ya tiene Z o offset (+05:00, -0500), respetar
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  return new Date(s + 'Z');
}

export function tiempoRelativo(fechaIso) {
  const ahora = new Date();
  const fecha = parsearFechaBackend(fechaIso);
  if (!fecha) return '';
  const diffMs = fecha - ahora;
  const diffMin = Math.round(diffMs / 60000);
  const absMin = Math.abs(diffMin);
  if (absMin < 60) return rtf.format(diffMin, 'minute');
  const diffH = Math.round(diffMin / 60);
  if (Math.abs(diffH) < 24) return rtf.format(diffH, 'hour');
  const diffD = Math.round(diffH / 24);
  return rtf.format(diffD, 'day');
}

export function fechaCorta(fechaIso) {
  const d = parsearFechaBackend(fechaIso);
  if (!d) return '';
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short' });
}

export function fechaLarga(fechaIso) {
  const d = parsearFechaBackend(fechaIso);
  if (!d) return '';
  return d.toLocaleDateString('es-CO', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

/// Fecha y hora completa en zona Colombia (ideal para auditoría).
/// Ejemplo: "8/9/2026, 12:17:11 a. m."
export function fechaHoraLocal(fechaIso) {
  const d = parsearFechaBackend(fechaIso);
  if (!d) return '';
  return d.toLocaleString('es-CO', { timeZone: 'America/Bogota' });
}

/// Solo fecha en zona Colombia (día/mes/año largo).
/// Ejemplo: "8 sept 2026"
export function fechaLocal(fechaIso) {
  const d = parsearFechaBackend(fechaIso);
  if (!d) return '';
  return d.toLocaleDateString('es-CO', {
    day: '2-digit', month: 'short', year: 'numeric',
    timeZone: 'America/Bogota',
  });
}

export const iniciales = (nombre = '') =>
  nombre
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || '')
    .join('');
